
























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {IUserEdit} from "../_objects/IUser";
import {store} from "@/_store";
import {create, update} from "@/_services/user.services";
import {SNACK_ACTION} from "@/_store/snackbar";

@Component
export default class UsersEdit extends Vue {
    @Prop() private user!: IUserEdit;
    @Prop({default: false}) private show!: string;
    @Prop() private data!: {};
    private loading: boolean = false;
    private firstRules = [
        (v: string) => !!v || 'First name is required',
     ];
    private lastRules = [
        (v: string) => !!v || 'Last name is required',
    ];
    private emailRules = [
        (v: string) => !!v || 'E-mail is required',
        (v: string) => /.+@.+/.test(v) || 'E-mail must be valid',
    ];
    private companyRules = [
        (v: string) => !!v || 'Company is required',
    ];

    get isEdit() {
        return !!this.user.id;
    }
    private close() {
        this.$emit('update:show', false);
    }

    private async save() {
        if ((this.$refs.form as any).validate()) {
            this.loading = true;
            if (!this.isEdit) {
                try {
                    const newUser = await create(this.user);
                    if (newUser) {
                        store.dispatch(SNACK_ACTION.SUCCESS, `<b>${this.user.first} ${this.user.last}</b> has been created.`);
                        this.$emit('update:show', false);
                        this.$emit('success', true);
                    }
                } catch (err) {
                    // Do nothing
                }
            } else {
                try {
                    const newUser = await update(this.user);
                    if (newUser) {
                        store.dispatch(SNACK_ACTION.SUCCESS, `<b>${this.user.first} ${this.user.last}</b> has been updated.`);
                        this.$emit('update:show', false);
                        this.$emit('success', true);
                    }
                } catch (err) {
                    // Do nothing
                }
            }
            this.loading = false;
        }
    }

    @Watch('user')
    private onUserChanged() {
        (this.$refs.form as any).resetValidation();
    }

}
